import { createAsyncThunk } from '@reduxjs/toolkit';
import { DownloadOrderDetails } from '../../../client/services';

export const getDownloadOrderDetails = createAsyncThunk(
  'downloadOrderDetails/getDownloadOrderDetails',
  async (params: { id: string }) => {
    const response = await DownloadOrderDetails.get(params.id);
    return response;
  }
);
